import { useEffect, useState } from "react";

export function StalenessBadge({
  lastEventTs,
  wsState,
  onRefresh,
}: {
  lastEventTs: number;
  wsState: "connecting" | "open" | "closed";
  onRefresh: () => void;
}) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const ageMs = now - lastEventTs;
  const ageSec = Math.round(ageMs / 1000);
  const tone =
    wsState !== "open" || ageMs > 300_000 ? "text-bad"
      : ageMs > 60_000 ? "text-warn"
      : "text-mist";
  const label =
    ageSec < 60 ? `${ageSec}s ago`
    : ageSec < 3600 ? `${Math.round(ageSec / 60)}m ago`
    : `${Math.round(ageSec / 3600)}h ago`;
  return (
    <button
      onClick={onRefresh}
      title="Click to force refresh"
      className={`fixed bottom-3 right-3 z-20 text-[11px] font-mono border border-edge bg-panel/90 backdrop-blur px-2 py-1 rounded hover:border-mist ${tone}`}
    >
      {wsState === "open" ? "●" : wsState === "connecting" ? "◌" : "○"} updated {label}
    </button>
  );
}
